import { useEffect } from "react";

const GA_ID = "G-JM1J0K408S";

const loadGTM = () => {
  if (window.__gtmLoaded) return;
  window.__gtmLoaded = true;

  window.dataLayer = window.dataLayer || [];
  function gtag() { window.dataLayer.push(arguments); }
  window.gtag = gtag;
  gtag("js", new Date());
  gtag("config", GA_ID);

  const s = document.createElement("script");
  s.src = `https://www.googletagmanager.com/gtag/js?id=${GA_ID}`;
  s.async = true;
  document.head.appendChild(s);
};

const GoogleAnalyticsScript = () => {
  useEffect(() => {
    const events = ["scroll", "click", "touchstart", "keydown"];
    const handler = () => {
      loadGTM();
      events.forEach((e) => window.removeEventListener(e, handler));
    };
    events.forEach((e) => window.addEventListener(e, handler, { passive: true, once: true }));

    const timer = setTimeout(loadGTM, 5000);

    return () => {
      clearTimeout(timer);
      events.forEach((e) => window.removeEventListener(e, handler));
    };
  }, []);

  return null;
};

export default GoogleAnalyticsScript;
